<template>
  <main v-if="operation && formId">
    <div
      v-if="loading"
      class="fixed bg-black/70 w-full h-full inset-0 z-50 flex justify-center items-center p-6 text-white font-bold"
    >
      Validation en cours ...
    </div>
    <div
      v-if="error"
      class="fixed bg-black/70 w-full h-full inset-0 z-50 flex justify-center items-center p-6 text-white font-bold"
    >
      <div
        class="bg-red-50 text-red-700 w-full max-w-sm p-4 rounded m-auto text-center"
      >
        Une erreur est survenue
        <p class="font-normal p-4">
          {{ errorMessage || "Vérifiez les champs que vous avez renseignés" }}
        </p>
        <button @click="error = false; errorMessage = ''" class="button !bg-red-700 mb-2">Fermer</button>
      </div>
    </div>

    <div class="w-full max-w-3xl md:m-auto mx-6">
      <h1 class="text-center w-full font-bold py-8">
        {{ operation.title.split(" - ")[1] }}
      </h1>
      <Form
        id="monform"
        :form_id="formId"
        :uid="uid"
        :submission_id="id"
        :server="server"
        v-on:results="getResult"
        v-on:form_submit_loading="loading"
        @on_error="showErrorForm"
        :hideError="hiderror"
      />
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router/composables";
const route = useRoute();
const server = ref("https://api.husqvarna-promo.fr");
const id = ref(route.params._id);
const uid = ref(route.params.uid);
const hiderror = ref(true);
const loading = ref(false);
const formId = ref(null);
const operation = ref(null);
const done = ref(false);
const error = ref(false);
const errorMessage = ref("");

const fetchSubmission = async () => {
  try {
    const response = await fetch(
      `https://api.husqvarna-promo.fr/api/v2/submissions/${id.value}?uid=${uid.value}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP: ${response.status}`);
    }

    const data = await response.json();

    const op = await fetch(
      `https://api.husqvarna-promo.fr/api/v2/formdata/${data.operationId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const dataOp = await op.json();
    if (dataOp.forms && dataOp.forms.length > 0) {
      dataOp.forms = dataOp.forms.filter((form) => form.type === "UPDATE");
    }

    operation.value = dataOp;
    return data;
  } catch (error) {
    console.error(`Erreur lors de la requête pour l'ID ${id.value}:`, error);
    throw error;
  }
};

onMounted(async () => {
  try {
    const sub = await fetchSubmission();
    if (sub._id) {
      id.value = sub._id;
      uid.value = sub.uid;

      if (operation.value.date_fin_regule) {
        const dateFin = new Date(operation.value.date_fin_regule);
        const now = new Date();
        if (now > dateFin) {
          window.location.href = "/";
          return;
        }
      }

      formId.value = operation.value.forms[0]._id;
      console.log("id", id.value);
      console.log("uid", uid.value);
    } else {
      console.error("No submission found");
    }
  } catch (e) {
    console.error(e);
  }
});

const getResult = (result) => {
  if (result) {
    done.value = true;
    location.reload();
  }
};

const showErrorForm = (errorData) => {
  loading.value = false;
  error.value = true;
  if (errorData && errorData.error && errorData.error.message) {
    errorMessage.value = errorData.error.message;
  }
};
</script>

<style>
.upload-btn-wrapper {
  @apply flex bg-gray-100;

  svg {
    @apply mr-2;
  }
}
</style>
